import { useState } from "react";
import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Image from "@/components/image";
import Text from "@/components/text/text";
import Joystick from "../controls/exploration/joystick";
import { useModelViewerStore } from "@/store/modelViewerStore";
import ModelViewerPanel from "@/components/controls/modelViewer/modelViewer-panel";

const ModelViewerLayout = ({ children }: { children: React.ReactNode }) => {
  const setPositionJoystickData = useModelViewerStore(
    (state) => state.setPositionJoystickData,
  );
  const setRotationJoystickData = useModelViewerStore(
    (state) => state.setRotationJoystickData,
  );

  //const setIsAutoPlay = useModelViewerStore((state) => state.setIsAutoPlay);

  const handlePositionJoystickMove = (x: number, y: number) => {
    setPositionJoystickData([x, y]);
  };

  const handlePositionJoystickRelease = () => {
    setPositionJoystickData([0, 0]);
  };

  const handleRotationJoystickMove = (x: number, y: number) => {
    setRotationJoystickData([x, y]);
  };

  const handleRotationJoystickRelease = () => {
    setRotationJoystickData([0, 0]);
  };

  // const Joysticks = () => {
  //   return (
  //     <div className="absolute bottom-0 left-0 right-0">
  //       <div className="flex fixed justify-between bottom-0 w-full px-[20px] mb-[20px]">
  //         <Joystick
  //           onMove={handlePositionJoystickMove}
  //           onRelease={handlePositionJoystickRelease}
  //           topChild={
  //             <Image
  //               src="/assets/icon_joystick_up.png"
  //               height={24}
  //               width={24}
  //             />
  //           }
  //           bottomChild={
  //             <Image
  //               src="/assets/icon_joystick_down.png"
  //               height={24}
  //               width={24}
  //             />
  //           }
  //           leftChild={
  //             <Image
  //               src="/assets/icon_joystick_left.png"
  //               height={24}
  //               width={24}
  //             />
  //           }
  //           rightChild={
  //             <Image
  //               src="/assets/icon_joystick_right.png"
  //               height={24}
  //               width={24}
  //             />
  //           }
  //         />
  //         <Joystick
  //           onMove={handleRotationJoystickMove}
  //           onRelease={handleRotationJoystickRelease}
  //           topChild={<Text text="joystick_up" size={10} />}
  //           bottomChild={<Text text="joystick_down" size={10} />}
  //           leftChild={
  //             <Image
  //               src="/assets/icon_joystick_rotate_left.png"
  //               height={20}
  //               width={20}
  //             />
  //           }
  //           rightChild={
  //             <Image
  //               src="/assets/icon_joystick_rotate_right.png"
  //               height={20}
  //               width={20}
  //             />
  //           }
  //         />
  //       </div>
  //     </div>
  //   );
  // };

  // const AutoPlayToggle = () => {
  //   const isAutoPlay = useModelViewerStore((state) => state.isAutoPlay);
  //   const startAutoPlayDelay = useModelViewerStore((state) => state.startAutoPlayDelay);
  //   const stopAutoPlay = useModelViewerStore((state) => state.stopAutoPlay);
  //   const [on, setOn] = useState(false);
  //   function handleToggle() {
  //     const currentValue = on;
  //     // const next = !on;
  //     // setOn(next);
  //     //setIsAutoPlay(!currentValue);
  //     if(currentValue){
  //       stopAutoPlay();
  //     }
  //     else{
  //       startAutoPlayDelay(0);
  //     }
      
  //   }

  //   useEffect(()=>{
  //     setOn(isAutoPlay);
  //   },[isAutoPlay])

  //   return (
  //     <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
  //       <div className="flex flex-col items-center w-full px-[20px] mb-[20px] pointer-events-none">
  //         <button
  //           id="autoPlayToggle"
  //           role="switch"
  //           aria-checked={on}
  //           onClick={handleToggle}
  //           onKeyDown={(e) => {
  //             if (e.key === "Enter" || e.key === " ") {
  //               e.preventDefault();
  //               handleToggle();
  //             }
  //           }}
  //           className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors focus:outline-none pointer-events-auto ${
  //             on ? "bg-green-500" : "bg-gray-300"
  //           }`}
  //           aria-labelledby={`autoPlayToggle-label`}
  //         >
  //           <span
  //             className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${
  //               on ? "translate-x-5" : "translate-x-1"
  //             }`}
  //           />
  //         </button>
  //         <Text text="Autoplay" size={20} />
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div className="fullscreen_div">
      {children}

{/*      <Joysticks />
      <AutoPlayToggle />*/}
      <div className="absolute bottom-0 left-0 right-0">
        <ModelViewerPanel/>
      </div>
    </div>
  );
};

export default ModelViewerLayout;
